import React from 'react'
import StyleSheet from 'styles'
import { baseTheme } from 'styles'

export default function Footer(props) {
  const currentYear = (new Date()).getFullYear()

  return (
    <div className={styles.root}>
      <div className={styles.copyright}>© {currentYear} {process.env.REACT_APP_NAME}. All Rights Reserved</div>
    </div>
  )
}

const styles = StyleSheet({
  root: {
    width: '100%',
    height: '61px',
    backgroundColor: '#1B3044',
    paddingTop: '25px',
    boxSizing: 'border-box',
    '@media print': {
      display: 'none',
    }
  },

  copyright: {
    fontSize: '12px',
    fontWeight: 'normal',
    color: '#ffffff',
    margin: 'auto',
    paddingLeft: '20px',
    boxSizing: 'border-box',
    maxWidth: baseTheme.siteStyleguide.maxWidth,
    width: '100%'
  }
}, {classNamePrefix: 'Footer-'})